<template>
  <div class="notice">
    <p style="margin:0;">This page has expired, please refresh and try again.</p>
    <div class="btn-link text-right">
      <s-btn link class="mr-5" @click="refresh">Refresh</s-btn>
      <!--<s-btn link @click="noRefresh">Cancel</s-btn>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'updateNotice',
  methods: {
    refresh() {
      location.reload()
    },
    // noRefresh() {
    //   this.$parent.close();
    // }
  },
}
</script>

<style scoped></style>
